import React, { useState, useEffect } from 'react';
import { getMarkDown } from '../utils';
import '../../../stylesheets/triagebot/OpenSummaryOptions.scss';
import { datadogRum } from '@datadog/browser-rum';
import NpsCard from './NpsCard';
import InfoButton from './InfoButton.js';
import Checkmark from '../../../assets/checkmark';
import { ReactComponent as SummaryOptionsArrow } from '../../../assets/SummaryOptionsArrow.svg';

const OpenSummaryOptions = ({ message, sendMessage, disabled, setSubmitted, setToastMessage, setselectedSelf911ERCard }) => {
    const [selected, setSelected] = useState('');
    const [editing, setEditing] = useState(false);

    const cdoName = message?.data?.[0]?.cdoName;
    const isOpenCdo = (cdoName || '').toLowerCase() === 'open';
    let selfCare911ERSelected = false;
    let selectedButtonRedirectUrl = '';
    let daggerNoteMarker = '†';
    const openHeaderText = message?.data?.[2]?.summaryCardContent?.openCareTypeHeader
        ? message.data[2].summaryCardContent.openCareTypeHeader
        : '';

    const openSubHeaderText = message?.data?.[2]?.summaryCardContent?.openCareTypeSubHeader
        ? message.data[2].summaryCardContent.openCareTypeSubHeader
        : '';

    const header = openHeaderText || "Open header text not provided";
    const subHeader = openSubHeaderText || "Open subheader text not provided";

    const isDisabled = disabled;

    const formatCode = message?.data?.[0]?.FormatCode
        ? message.data[0].FormatCode.toLowerCase()
        : 'unknown';

    const questionId = message?.data?.[0]?.question_id
        ? message.data[0].question_id
        : -1;

    const buttons = message?.data?.[2]?.careOptionsData?.careOptions
        ? message.data[2].careOptionsData.careOptions
        : [];

    const shouldRenderArrow = (buttonValue) => !['selfcare', 'nineoneone', 'emergencyroom'].includes((buttonValue || '').toLowerCase());

    const infoMean = (message?.data?.[0]?.infoMeaning)
    ? message.data[0].subHeaderText
    : 'What does this mean?';

    const getSummaryOptionWithIcons = (text, buttonValue, isSelected) => {
        const showDaggerIcon = ['virtualcare', 'inperson', 'urgentcare'].includes((buttonValue || '').toLowerCase());

        return (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>
                {text}
                {showDaggerIcon && <sup className='dagger-icon'>{daggerNoteMarker}</sup>}
            </span>
            {!isSelected && <SummaryOptionsArrow className='summary-options-arrow' style={{ display: 'inline-block' }} />}
        </span>
    )};

if (typeof setToastMessage !== 'function')
        setToastMessage = () => { };

    if (typeof setSubmitted !== 'function')
        setSubmitted = () => { };


const resetSelection = () => {
        setSelected('');
        setselectedSelf911ERCard(false);
    };

const showToastMessage = () => {
        setToastMessage({
            type: 'nps',
            header: '',
            onClose: resetSelection,
            body: (
                <NpsCard
                    message={message}
                    sendMessage={sendMessage}
                    disabled={disabled}
                    selfCare911ERSelected={selfCare911ERSelected}
                    selectedButtonRedirectUrl={selectedButtonRedirectUrl}
                    onFeedbackSubmit={setSubmitted}
                    closeToast={(shouldResetSelection = false) => {
                        if (shouldResetSelection) {
                            resetSelection();
                        }
                        setToastMessage(null);
                    }}
                />
            )
        });
    };
    
    const buttonPress = (button) => {
     selfCare911ERSelected = isOpenCdo && (button.value.toLowerCase() === 'selfcare' || button.value.toLowerCase() === 'nineoneone' || button.value.toLowerCase() === 'emergencyroom');
        selectedButtonRedirectUrl = button.redirectUrl ? button.redirectUrl : '';
        setSelected(button.value);
         setselectedSelf911ERCard(selfCare911ERSelected);

                if (selfCare911ERSelected) {
                        // Self-care/911 doesn't use toast flow; disable summary options immediately.
                        setSubmitted(true);
                }

            if(!selfCare911ERSelected){
                showToastMessage();
            }            
            datadogRum.setViewContextProperty('careType', button.value);        
            let value = button.value || 'none';

            editing
                ? sendMessage('message', `##edit@${questionId}@${value}`, `##edit@${questionId}@${value}`)
                : sendMessage('message', value, value);
    
    }

    useEffect(() => {
        if (message.unsubmit) {
            setSelected('');
            setSubmitted(false);
            setEditing(true);
            message.unsubmit = false;
                        selectedButtonRedirectUrl = '';
            selfCare911ERSelected = false;
        }
    });

    return (
        <>
            {
                buttons.length !== 0
                    ?
                    <div className={`options ${isOpenCdo ? 'open-cdo-options' : ''}`.trim()}>
                        <div className={(isDisabled ? 'disableColor' : '')}>
                            <div className={'header ' + formatCode} tabIndex={isDisabled ? '-1' : '0'}>
                                <h2 className='headerText'>{getMarkDown(header)}</h2>
                            </div>

                            {
                                subHeader &&
                                <div className='subheader'>
                                    {getMarkDown(subHeader)}
                                </div>
                            }

                            {
                                buttons.map((button, index) => {
                                    const isSelected = selected === button.value;
                                    const checkmarkId = `${questionId || 'open-summary-options'}-${index}`;
                                    return (
                                        <div key={button.value}>
                                            <div className='care-option-row'>
                                                <button
                                                    data-name={button.value}
                                                    key={index}
                                                    className={isSelected ? 'single-select btn-inline selected' : 'single-select btn-inline'}
                                                    onClick={() => buttonPress(button)}
                                                    disabled={isDisabled}
                                                >
                                                    <input type='radio' name='care-type' style={{ display: 'none' }} id={button.displayText.toLowerCase()} />
                                                    <label htmlFor={button.displayText.toLowerCase()}>
                                                        {isSelected && (
                                                            <Checkmark
                                                                className='checkmark'
                                                                role='img'
                                                                ariaLabelledby={`${checkmarkId}-selected`}
                                                                id={checkmarkId}
                                                            />
                                                        )}
                                                        {shouldRenderArrow(button.value)
                                                            ? getSummaryOptionWithIcons(button.displayText, button.value, isSelected)
                                                            : button.displayText}
                                                    </label>
                                                </button>
                                                {
                                                   (button.explication && button.explication?.text !== '') &&
                                                    <InfoButton
                                                     disabled={isDisabled}
                                                      header={infoMean}
                                                      ariaText={button.displayText}
                                                      explication={button.explication?.text}
                                                      onShowInfo={setToastMessage}
                                                      isOpenCdo={isOpenCdo}
                                                       />
                                                    }
                                            </div>
                                        </div>
                                    );
                                })
                            }

                        </div>
                    </div>
                    :
                    <></>
            }
        </>
    );
};

export default OpenSummaryOptions;
